module.exports = __webpack_public_path__ + "static/img/game7.36a867d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game7.jpg
// module id = 7xQC
// module chunks = 1